import http from '@/http'

export default {

    /**
     * Runs a MOCO dry-run and stores the resulting report.
     */
    async mocoDryRun({ commit }, { includeContacts = true, includeUsers = true } = {}) {
        const response = await http({
            method: 'GET',
            url: 'moco/sync/dry-run',
            params: { includeContacts, includeUsers },
        })
        commit('SET_DRY_RUN', response.data)
        return response.data
    },

    /**
     * Executes the real MOCO sync and stores the resulting counters.
     */
    async mocoSyncRun({ commit }, { includeContacts = true, includeUsers = true } = {}) {
        const response = await http({
            method: 'POST',
            url: 'moco/sync/run',
            params: { includeContacts, includeUsers },
        })
        commit('SET_SYNC_RESULT', response.data)
        return response.data
    },

    /**
     * Loads the current MOCO settings from the server.
     */
    async loadMocoSettings({ commit }) {
        const response = await http({ method: 'GET', url: 'moco/settings' })
        commit('SET_MOCO_SETTINGS', response.data)
        return response.data
    },

    /**
     * Persists the MOCO settings on the server and stores the submitted values.
     */
    async saveMocoSettings({ commit }, settings) {
        await http({ method: 'PUT', url: 'moco/settings', data: settings })
        commit('SET_MOCO_SETTINGS', settings)
        return settings
    },

    /**
     * Downloads a SQL dump of the given database as a blob.
     */
    async exportDatabase(_, database) {
        const response = await http({
            method: 'GET',
            url: 'admin/database/export',
            params: { database },
            responseType: 'blob',
        })
        return response.data
    },

    /**
     * Drops and recreates the given database (staging reset).
     */
    async dropDatabase(_, database) {
        await http({ method: 'POST', url: 'admin/database/drop', params: { database } })
    },

    /**
     * Restores the given database from an uploaded SQL file.
     */
    async restoreDatabase(_, { database, file }) {
        const formData = new FormData()
        formData.append('file', file)
        await http({ method: 'POST', url: 'admin/database/restore', params: { database }, data: formData })
    },

    /**
     * Loads the health status of all services.
     */
    async loadServiceStatus() {
        const response = await http({ method: 'GET', url: 'admin/services/status' })
        return response.data
    },

    /**
     * Loads the MOCO sync schedule (cron) configuration.
     */
    async loadMocoSyncSchedule() {
        const response = await http({ method: 'GET', url: 'moco/sync/schedule' })
        return response.data
    },

    /**
     * Persists the MOCO sync schedule (cron) configuration.
     */
    async saveMocoSyncSchedule(_, schedule) {
        await http({ method: 'PUT', url: 'moco/sync/schedule', data: schedule })
        return schedule
    },

}
